/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ExternalServiceType } from './ExternalServiceType.js';
import {
    ExternalServiceTypeFromJSON,
    ExternalServiceTypeFromJSONTyped,
    ExternalServiceTypeToJSON,
} from './ExternalServiceType.js';

/**
 * 
 * @export
 * @interface UpdateExternalServiceRequest
 */
export interface UpdateExternalServiceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateExternalServiceRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateExternalServiceRequest
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof UpdateExternalServiceRequest
     */
    options?: any;
    /**
     * 
     * @type {ExternalServiceType}
     * @memberof UpdateExternalServiceRequest
     */
    type?: ExternalServiceType;
}

/**
 * Check if a given object implements the UpdateExternalServiceRequest interface.
 */
export function instanceOfUpdateExternalServiceRequest(value: object): boolean {
    return true;
}

export function UpdateExternalServiceRequestFromJSON(json: any): UpdateExternalServiceRequest {
    return UpdateExternalServiceRequestFromJSONTyped(json, false);
}

export function UpdateExternalServiceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateExternalServiceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'options': json['options'] == null ? undefined : json['options'],
        'type': json['type'] == null ? undefined : ExternalServiceTypeFromJSON(json['type']),
    };
}

export function UpdateExternalServiceRequestToJSON(value?: UpdateExternalServiceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'options': value['options'],
        'type': ExternalServiceTypeToJSON(value['type']),
    };
}

